import AdultSwimVideoPlayer from './player';

require('./styles/app.less');

// creates the ASVideoPlayer instance, which in turn creates the video.js player instance
// element should be a video html element's ID
// videoID should be a unicron ID
// options is a video.js options object
function ASVideoPlayer(element, videoID, options) {
    if (!arguments.length) element = 'video-player';
    if (arguments.length <= 1) { videoID = ''; options = {}; }
    if (arguments.length <= 2) options = {};

    if (typeof element !== 'string') {
        console.warn('The first argument for ASVideoPlayer.create should be a string of the ID of the video HTML element.  Defaulting to \'video-player\'');
        element = 'video-player';
    }

    if (typeof videoID !== 'string') {
        console.warn('The second argument for ASVideoPlayer.create should be a string of the ID of the unicron video asset.  Defaulting to false');
        videoID = false;
    }

    if (typeof options !== 'object' || Array.isArray(options)) {
        console.warn('The third argument for ASVideoPlayer.create should be an object of the video.js options for overriding it\'s defaults.  Defaulting to \'{}\'');
        options = {};
    }

    this.name = 'ASVideoPlayer';

    this.player = new AdultSwimVideoPlayer({
        element: element,
        videoID: videoID,
        options: options
    });

    return this;
}

// registers player event listening
// use html5 video player event names - progress, loadstart, end, etc
ASVideoPlayer.prototype.registerEvent = function (eventName, callback) {
    if (!this.player) {
        console.error('ASVideoPlayer not created yet.  Cannot register event.');
        return false;
    }

    if (arguments.length !== 2) {
        console.error('Missing one or more arguments in registerEvent call.  Needs both eventName and callback function in that order.');
        return false;
    }

    return this.player.registerEvent(eventName, callback);
};

// deregisters player event listening
ASVideoPlayer.prototype.deregisterEvent = function (eventName, func) {
    if (!this.player) {
        console.error('ASVideoPlayer not created yet.  Cannot deregister event.');
        return false;
    }

    if (!arguments.length) {
        console.error('Missing a required argument in deregisterEvent call.  Needs eventName passed in.');
        return false;
    }

    this.player.deregisterEvent(eventName, func);
};

// returns the actual player so you can call player methods
// pause, play, stop, volume, etc
ASVideoPlayer.prototype.getPlayer = function () {
    if (!this.player) {
        console.error('ASVideoPlayer not created yet.  Cannot retrieve player.');
        return false;
    }

    return this.player.getPlayer();
};

// use to set a new video (using unicron ids)
// will clear out current video and request new one
// doesn't start playing until you tell it to
// allows for you to pass in a callback that fires on success
ASVideoPlayer.prototype.setVideo = function (videoID, options) {
    if (!this.player) {
        console.error('ASVideoPlayer not created yet.  Cannot register event.');
        return false;
    }

    if (!arguments.length) {
        console.error('No arguments passed to setVideo.  It needs a unicron video ID to retrieve video assets.');
        return false;
    }

    if (arguments.length === 1) {
        console.warn('The second argument for ASVideoPlayer.setVideo should be an object with success and/or error properties as functions.  Defaulting to \'{}\'');
    }

    options = options || {};

    var currentVideoID = (this.player.videoData) ? this.player.videoData.id : null;

    if (videoID === currentVideoID) {
        console.warn('Video already playing videoID: ' + videoID);
        if (options.success) options.success();
        return true;
    }

    this.player.setVideo(videoID, {
        success: (options.success) ? options.success : null,
        error: options.error ? options.error : null
    });
};

// destroys everything - video.js, backbone views and model, video tag
ASVideoPlayer.prototype.destroy = function (destroyVideoTag) {
    if (!this.player) {
        console.error('ASVideoPlayer not created yet.  Cannot destroy video player.');
        return false;
    }

    // if passing true, destroy will replace the original video tag
    if (!arguments.length) destroyVideoTag = true;

    this.player.destroy(destroyVideoTag);
};

module.exports = ASVideoPlayer;


// WEBPACK FOOTER //
// ./src/index.js